/* @flow */
import CurrentUser from 'auth/CurrentUser';
import Electron from 'lib/Electron';

/**
  This class is for storing user settings locally using localStorage
  These settings can be set/get on a per-(Current)user basis
*/
class LocalUserSettings {
  isEnabled() {
    try {
      window.localStorage.setItem('local_storage_check', 'check');
      window.localStorage.removeItem('local_storage_check');
      return true;
    } catch (e) {
      // e.g. no window or no storage capability
      return false;
    }
  }

  _setItem(key: string, value: mixed): void {
    if (!this.isEnabled()) {
      throw new Error('localStorage not available');
    }
    const stringifiedValue = typeof value === 'string' ? value : JSON.stringify(value);
    window.localStorage.setItem(key, stringifiedValue);
  }

  _getItem(key: string): ?Object {
    if (!this.isEnabled()) {
      throw new Error('localStorage not available');
    }
    const value = window.localStorage.getItem(key);
    return JSON.parse(value);
  }

  _getUserList() {
    const result = this._getItem('local_user_properties');
    if (result) {
      return result;
    } else {
      this._setItem('local_user_properties', {});
      return {};
    }
  }

  _getDefaultUserProperties() {
    return {
      prompts: [],
      settings: {
        displayWebNotifications: Electron.isAvailable(),
      },
    };
  }

  updateUser(properties: Object): void {
    const users = this._getUserList();
    users[CurrentUser.getUserId()] = Object.assign(this.getUserProperties(), properties);
    this._setItem('local_user_properties', users);
  }

  getUserProperties() {
    return this._getUserList()[CurrentUser.getUserId()] || this._getDefaultUserProperties();
  }
}

export default new LocalUserSettings();



// WEBPACK FOOTER //
// ./src/lib/LocalUserSettings.js